const CryptoJS = require("crypto-js");
// (2026-05-13) Nueva clave estandarizada para AES (URL params + payloads sensibles).
const secretKey = "d41d8cd98f00b204e9800998ecf8427e";

// Función para encriptar el texto (AES-CBC con clave compartida).
export function encryptText(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, secretKey).toString();
  return encrypted;
}

// Función para desencriptar el texto (AES-CBC con clave compartida).
export function decryptText(encryptedText) {
  const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8); // Convierte los bytes a texto legible
  return decrypted;
}

/**
 * (2026-05-13) Hash SHA-256 hex (64 chars) del input. Se usa para enviar
 * contraseñas al backend en modo AUTH_HASH_MODE='sha256'. El backend espera
 * exactamente este formato y rechaza cualquier otro cuando ese modo está activo.
 *
 *   hashPassword("admin12345")
 *   // -> "ef797c8118f02dfb649607dd5d3f8c7623048c9c063d532cc95c5ed7a898a64f"
 *
 * Notas:
 * - No usa salt. La protección contra rainbow tables vive en el backend
 *   (bcrypt sobre el SHA-256 recibido).
 * - El input puede ser cualquier string; el método ya maneja UTF-8 internamente.
 */
export function hashPassword(plainPassword) {
  if (plainPassword == null) return "";
  return CryptoJS.SHA256(String(plainPassword)).toString(CryptoJS.enc.Hex);
}